import { render, staticRenderFns } from "./CbsTodo.vue?vue&type=template&id=1dda03f5&scoped=true"
import script from "./CbsTodo.vue?vue&type=script&lang=js"
export * from "./CbsTodo.vue?vue&type=script&lang=js"
import style0 from "./CbsTodo.vue?vue&type=style&index=0&id=1dda03f5&prod&lang=scss&scoped=true"
import style1 from "./CbsTodo.vue?vue&type=style&index=1&id=1dda03f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dda03f5",
  null
  
)

export default component.exports